export default __webpack_public_path__ + "static/media/Banner img 1.4aac64bb.svg";